var map = {
	"./badesee-petershagen/assets/img/sup.webp": [
		32247,
		2247
	],
	"./demo/assets/img/sup.webp": [
		9204,
		9204
	],
	"./dhu/assets/img/sup.webp": [
		18816,
		8816
	],
	"./kolula/assets/img/sup.webp": [
		21935,
		1935
	],
	"./neuland/assets/img/sup.webp": [
		85298,
		5298
	],
	"./seezeit/assets/img/sup.webp": [
		67428,
		7428
	],
	"./solheimsviken/assets/img/sup.webp": [
		14286,
		4286
	],
	"./strandbad-pertisau/assets/img/sup.webp": [
		36450,
		6450
	],
	"./vonovia/assets/img/sup.webp": [
		4205,
		4205
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 1 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 88223;
module.exports = webpackAsyncContext;